WiseMetering.Collection.Reports = WiseMetering.Collection.extend({
    model: WiseMetering.Model.Report,
    url: '/reports',
    hasOrganization: true,

    findBySiteId: function(siteId = null) {
        return new WiseMetering.Collection.Reports(this.filter(report => report.get('site_id') === siteId));
    }
});
